interface Props {
  children: React.ReactNode;
  className?: string;
}
export function Card({ children, className = '' }: Props) {
  return (
    <div className={`rounded-lg border border-arcforge-100 bg-white p-5 shadow-sm ${className}`}>
      {children}
    </div>
  );
}
